/**
 * @generated SignedSource<<022377c637120385d5a8d5c3bac0f6c7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuySharedAsyncModules_buyPage$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedPersonalizedSearchItems_itemSearch" | "SharedRecentSales_itemSearch" | "SharedYMAL_itemSearch">;
  readonly " $fragmentType": "BuySharedAsyncModules_buyPage";
};
export type BuySharedAsyncModules_buyPage$key = {
  readonly " $data"?: BuySharedAsyncModules_buyPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuySharedAsyncModules_buyPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedAsyncModules_buyPage",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentSales_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedYMAL_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuySharedPersonalizedSearchItems_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "81973980c597aeedde135f0974dd23f2";

export default node;
